<div
  class="theme-selector"
  role="radiogroup">
  @for (theme of availableThemes; track theme) {
    <label
      class="option"
      [attr.data-selected]="currentTheme() === theme">
      <input
        type="radio"
        [name]="groupName"
        [value]="theme"
        [checked]="currentTheme() === theme"
        (change)="currentTheme.set(theme)" />
      <img
        [src]="`/assets/theme/${theme}.webp`"
        alt="" />
      <span class="name">{{ labels()[theme] }}</span>
    </label>
  }
</div>
